module.exports = __webpack_public_path__ + "static/heavy_ugl2-c577b6dad4cbfd5661531b3c2fc69feb.jpg";